import { matchesState } from './matchesState';
export function mapState(stateMap, stateId) {
    var foundStateId;
    Object.keys(stateMap).forEach(function (mappedStateId) {
        if (matchesState(mappedStateId, stateId) &&
            (!foundStateId || stateId.length > foundStateId.length)) {
            foundStateId = mappedStateId;
        }
    });
    return stateMap[foundStateId];
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/xstate/es/mapState.js
// module id = 1610
// module chunks = 0